export const variablesList = {
  deepBlueTheme: {
    defaultTabBg: '#5eaec6',
    tabSelected: '#053170',
    iconButtonBg: '#053170',
    iconButtonBgHover: '#63a0c0',
    menuBackground: '#053170',
    menuBorder: '1px solid #5eaec6',
    buttonPrimaryBgHover: '#63a0c0',
    menuColor: '#FFFFFF',
    menuColorHover: '#ffb58a',
    menuItemBg: '#c065a2',
    colorBorder: '2px solid #053170',
    checkboxBorder: '2px solid #053170',
    colorTypography: '#053170',
    tableCellColor: '#FFFFFF',
    datePickerDayColor: '#053170',
    tableBorder: '#5eaec6',
    bgColor: '#93b1c1',
    nestedTableBorder: '1px solid #5eaec6'
  },
  deepNavyTheme: {
    defaultTabBg: '#3a68aa',
    tabSelected: '#1b1860',
    iconButtonBg: '#1b1860',
    iconButtonBgHover: '#3a68aa',
    menuBackground: '#1b1860',
    menuBorder: '1px solid #44a7fb',
    buttonPrimaryBgHover: '#3a68aa',
    menuColor: '#FFFFFF',
    menuColorHover: '#f69906',
    menuItemBg: '#765cc9',
    colorBorder: '2px solid #1b1860',
    checkboxBorder: '2px solid #1b1860',
    colorTypography: '#1b1860',
    tableCellColor: '#FFFFFF',
    datePickerDayColor: '#1b1860',
    tableBorder: '#44a7fb',
    bgColor: '#1a3e5c',
    nestedTableBorder: '1px solid #44a7fb'
  },
  darkUITheme: {
    defaultTabBg: '#141c2a',
    tabSelected: '#44a7fb',
    iconButtonBg: '#3a68aa',
    iconButtonBgHover: '#2c5280',
    menuBackground: '#010405',
    menuBorder: '1px solid #3a68aa',
    buttonPrimaryBgHover: '#2c5280',
    menuColor: '#ffffff',
    menuColorHover: '#44a7fb',
    menuItemBg: '#0b1220',
    colorBorder: '2px solid #3a68aa',
    checkboxBorder: '2px solid #44a7fb',
    colorTypography: '#ffffff',
    tableCellColor: '#ffffff',
    datePickerDayColor: '#44a7fb',
    tableBorder: '#3a68aa',
    bgColor: '#0b1220',
    nestedTableBorder: '1px solid #3a68aa'
  },
  lightUITheme: {
    defaultTabBg: '#E5E7EB',
    tabSelected: 'rgb(58 83 127)',
    iconButtonBg: 'rgb(87 113 158)',
    iconButtonBgHover: '#145ABD',
    menuBackground: '#111111',
    menuBorder: '1px solid #A0AEC0',
    buttonPrimaryBgHover: 'rgb(87 113 158)',
    menuColor: '#ffffff',
    menuColorHover: 'rgb(87 113 158)',
    menuItemBg: '#D6E4FF',
    colorBorder: '2px solid #63A0C0',
    checkboxBorder: '2px solid rgb(87 113 158)',
    colorTypography: '#111111',
    tableCellColor: '#111111',
    datePickerDayColor: 'rgb(87 113 158)',
    tableBorder: '#A0AEC0',
    bgColor: '#FFFFFF',
    nestedTableBorder: '1px solid #A0AEC0'
  },
  pinkUITheme: {
    defaultTabBg: '#FFD6E0',
    tabSelected: '#C065A2',
    iconButtonBg: '#C065A2',
    iconButtonBgHover: '#A0548C',
    menuBackground: '#111111',
    menuBorder: '1px solid #C065A2',
    buttonPrimaryBgHover: '#A0548C',
    menuColor: '#ffffff',
    menuColorHover: '#C065A2',
    menuItemBg: '#F8E6F1',
    colorBorder: '2px solid #C065A2',
    checkboxBorder: '2px solid #C065A2',
    colorTypography: '#111111',
    tableCellColor: '#111111',
    datePickerDayColor: '#C065A2',
    tableBorder: '#A0AEC0',
    bgColor: '#FFFFFF',
    nestedTableBorder: '1px solid #C065A2'
  },
  bluishTheme: {
    defaultTabBg: '#E3E8EC',
    tabSelected: 'rgb(60 81 97)',
    iconButtonBg: 'rgb(60 81 97)',
    iconButtonBgHover: '#314553',

    menuBackground: '#F6F3EE',
    bgColor: 'rgb(191 212 227)',

    menuBorder: '1px solid #7E919F',
    buttonPrimaryBgHover: '#314553',

    menuColor: '#2A3944',
    menuColorHover: 'rgb(60 81 97)',

    menuItemBg: '#E8E1D8',

    colorBorder: '2px solid #7E919F',
    checkboxBorder: '2px solid #7E919F',

    colorTypography: '#2A3944',
    tableCellColor: '#2A3944',

    datePickerDayColor: 'rgb(60 81 97)',

    tableBorder: '#CBBFB2',

    nestedTableBorder: '1px solid #7E919F'
    // defaultTabBg: '#C8E1FF',
    // tabSelected: '#1A73E8',
    // iconButtonBg: '#1A73E8',
    // iconButtonBgHover: '#145ABD',
    // menuBackground: '#FFFFFF',
    // menuBorder: '1px solid #1A73E8',
    // buttonPrimaryBgHover: '#145ABD',
    // menuColor: '#0D1B2A',
    // menuColorHover: '#1A73E8',
    // menuItemBg: '#D9E3F0',
    // colorBorder: '2px solid #1A73E8',
    // checkboxBorder: '2px solid #1A73E8',
    // colorTypography: '#0D1B2A',
    // tableCellColor: '#0D1B2A',
    // datePickerDayColor: '#1A73E8',
    // tableBorder: '#A0AEC0',
    // bgColor: '#EAF2FB',
    // nestedTableBorder: '1px solid #1A73E8'
  },
  greenModeTheme: {
    defaultTabBg: '#D9F2E2',
    tabSelected: '#2E8B57',
    iconButtonBg: '#2E8B57',
    iconButtonBgHover: '#1F5E3A',
    menuBackground: '#111111',
    menuBorder: '1px solid #2E8B57',
    buttonPrimaryBgHover: '#1F5E3A',
    menuColor: '#ffffff',
    menuColorHover: '#2E8B57',
    menuItemBg: '#E6F4EA',
    colorBorder: '2px solid #2E8B57',
    checkboxBorder: '2px solid #2E8B57',
    colorTypography: '#111111',
    tableCellColor: '#111111',
    datePickerDayColor: '#2E8B57',
    tableBorder: '#DCE5DD',
    bgColor: '#F1F8F4',
    nestedTableBorder: '1px solid #2E8B57'
  },
  lilacTheme: {
    defaultTabBg: '#E8E9F7',
    tabSelected: '#9A97D6',
    iconButtonBg: '#9A97D6',
    iconButtonBgHover: '#7F7BC4',
    menuBackground: '#2F2C5A',
    menuBorder: '1px solid #9A97D6',
    buttonPrimaryBgHover: '#7F7BC4',
    menuColor: '#FFFFFF',
    menuColorHover: '#E8E9F7',
    menuItemBg: '#F4F5FD',
    colorBorder: '2px solid #9A97D6',
    checkboxBorder: '2px solid #9A97D6',
    colorTypography: '#2F2C5A',
    tableCellColor: '#2F2C5A',
    datePickerDayColor: '#9A97D6',
    tableBorder: '#E8E9F7',
    bgColor: '#FAFBFF',
    nestedTableBorder: '1px solid #E8E9F7'
  },
  turquoiseTheme: {
    defaultTabBg: '#B8F2E6',
    tabSelected: '#0F766E',
    iconButtonBg: '#0F766E',
    iconButtonBgHover: '#14B8A6',
    menuBackground: '#134E4A',
    menuBorder: '1px solid #14B8A6',
    buttonPrimaryBgHover: '#14B8A6',
    menuColor: '#FFFFFF',
    menuColorHover: '#99F6E4',
    menuItemBg: '#CCFBF1',
    colorBorder: '2px solid #0F766E',
    checkboxBorder: '2px solid #14B8A6',
    colorTypography: '#134E4A',
    tableCellColor: '#134E4A',
    datePickerDayColor: '#0F766E',
    tableBorder: '#5EEAD4',
    bgColor: '#F0FDFA',
    nestedTableBorder: '1px solid #5EEAD4',
    tabInactiveBackground: '#0D4A42',
    tabInactiveTextColor: 'rgba(255, 255, 255, 0.9)',
    tabInactiveOpacity: '0.8',
    tabActiveTextColor: '#FFFFFF',
    tabHoverBackground: 'rgba(0, 150, 136, 0.5)'
  }
};
